'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useSetupReadSpeaker = require('./useSetupReadSpeaker');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_useSetupReadSpeaker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }